
import Pagination from '@/components/pagination/index.vue';
import { getPageIndex } from '@/utils/common.js';
import Service from '../service.js';
import TypeService from '../../../../views/supply-and-demand/service.js';
export default {
  components: {
    Pagination
  },
  data() {
    return {
      pageType: '',
      pageSize: 10,
      pageNum: 1,
      total: 0,
      tableList: [],
      typeList: []
    };
  },
  watch: {
    $route: function () {
      this.pageType = this.$route.params.type;
      this.getTableList();
      this.getTypeList();
    }
  },
  created() {
    this.pageType = this.$route.params.type;
    this.getTableList();
    this.getTypeList();
  },
  methods: {
    getTypeList() {
      TypeService.getSubTypeList().then(res => {
        this.typeList = res;
      });
    },

    getTypeDesc(type) {
      const target = this.typeList.find(item => item.type === type);
      return target && target.name;
    },

    // 序号计算
    indexMethod(index) {
      return getPageIndex(this.pageNum, this.pageSize, index);
    },

    // 获取表格数据
    getTableList(page) {
      if (page && page.pageNo && page.pageSize) {
        this.pageNum = page.pageNo;
        this.pageSize = page.pageSize;
      }
      const query = {
        subType: this.pageType,
        tId: '66aaf74f247b9fffdb5eba08'
      };
      query.limit = this.pageSize;
      query.skip = (this.pageNum - 1) * this.pageSize;
      this.total = 0;
      this.tableList = [];
      Service.getList(query).then(res => {
        this.total = res.total;
        this.tableList = res.result;
      });
    },

    toDetail(item) {
      console.log(this.$route, item);
      this.$router.push('/supply-and-demand/detail?id=' + item._id);
    },

    deleteItem(item) {
      this.$confirm('请确认是否删除该条信息，删除后将不显示到供需大厅', '删除提示', {
        confirmButtonText: '确定删除',
        cancelButtonText: '关闭',
        type: 'warning'
      }).then(() => {
        Service.deleteItem({ id: item._id}).then(() => {
          this.$successMessage('删除成功');
          this.getTableList();
        }, error => {
          this.$errorMessage(error.reason || '删除失败');
        });
      }).catch();
    }

  }
};
